module.exports = __webpack_public_path__ + "img/logo-h.06ab4ab5.svg";